import React from "react";
import { Button, Modal, FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../../lib/context.js";
import ajax from "./../../lib/ajax.js";
import util from "./../../lib/util.js";
import immutable from "immutable";
import moment from "moment";
import PtoListByTimecard from "./../pto/pto-list-by-timecard.jsx";
import PtoDetail from "./../pto/pto-detail.jsx";

class MiscListItem extends React.Component {

    constructor(props) {
        super(props);
        this.openItem = this.openItem.bind(this);
    }

    openItem(action) {
        let vm = this.props.vm;

        if (vm.ptoLineId > 0) {
            if (action == "delete")
                this.props.onDeletePtoLine(vm.ptoLineId);
            else if (action == "approve")
                this.props.onApprovePto(vm.ptoId);
            else
                this.props.onOpenPto(action, vm.ptoId);
            return;
        }

        // regular Misc item
        if (action == "delete")
            this.props.onDelete(vm.expenseId);
        else
            this.props.onEdit(vm.expenseId)
    }

    render() {        
        let vm = this.props.vm;
        let allowTcEdit = (this.props.allowEdit == true || this.props.allowEdit == "true");
        let btnActions = [];
        
        // JNP: I'm not sure why we have these codes below
        //const tcStatus = this.props.timecardStatus
        //if (tcStatus == "Processed") {
        //    allowEdit = allowEdit && vm.status_code == "Processed";
        //}

        const btn = {
                ApprovePto  : <button key="btnApprove" className="approve" onClick={() => this.openItem("approve")}>Approve</button>,
                Edit        : <a key="btnEdit" onClick={() => this.openItem("edit")}><i className='fa fa-pencil-square-o'></i></a>,
                Delete      : <a key="btnDelete" onClick={() => this.openItem("delete")}><i className='fa fa-trash-o'></i></a>
            };

        if (allowTcEdit == true) {
            if (vm.ptoLineId > 0) {
                if (vm.ptoStatusCode == "Requested") {
                    if (this.props.onApprovePto) btnActions.push(btn.ApprovePto);
                    if (this.props.onOpenPto) btnActions.push(btn.Edit);
                }
                if (this.props.onDeletePtoLine) btnActions.push(btn.Delete);
            } 
            else {
                if (this.props.onEdit) btnActions.push(btn.Edit);
                if (this.props.onDelete) btnActions.push(btn.Delete);
            }
        }

        let unapprovedPtoIcon = null;
        let unapprovedPtoText = null;
        if (this.props.onDeletePtoLine) { // indicates current role is either Supervisor or Payroll Admin
            unapprovedPtoIcon = <span className={vm.ptoStatusCode == "Requested"? "ap-mr-1" : "ap-mr-1 ap-invisible"}>
                                    <i className='fa fa-suitcase ap-error-color'></i>
                                </span>;
            unapprovedPtoText = <span className={vm.ptoStatusCode == "Requested"? "unapproved-pto-text" : "hide"}>
                                    <i>Unapproved Time-Off</i> - Time-Off must be approved before verifying timecard(s)
                                </span>;
        }

        const clsColumnDesc = btnActions.includes(btn.ApprovePto)? "col-xs-3 col-md-7 text" : "col-xs-5 col-md-7 text";
        const clsColumnBtn = btnActions.includes(btn.ApprovePto)? "col-xs-4 col-md-2 button-panel" : "col-xs-2 col-md-2 button-panel";

        return (
            <div className="container-fluid ap-misc-list-item ap-color-darkgray ap-bkg-color-white">
                <div className="col-xs-2 col-md-1">
                    {/*unapprovedPtoIcon*/}
                    {moment(vm.expenseDate).format("MM/DD/YYYY")}
                </div>
                <div className="col-xs-3 col-md-2 unit">{util.toHrmString(vm.unit)}</div>
                <div className={clsColumnDesc}>{vm.description} {unapprovedPtoText}</div>
                <div className={btnActions.length > 0 ? clsColumnBtn : "ap-hidden"}>
                    {btnActions}
                </div>
            </div>
        );
    }
}

export default class MiscList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            showDialogErrorMessage: false,
            dialogErrorMessage: [],
            dialogMode: "new",
            editedExpense: null,
            totalExpense: 0,
            showMiscCodeDescription: false,
            miscCodeDescription: "",
            showScheduleHoursDay: false,
            scheduleHoursDay: null,
            showPtoDialog: false,
            showPtoListDialog: false,
            ptoDialogTitle: "",
            ptoAction: "",
            selectedPtoId: null
        };

        this.onOpenAddMisc = this.onOpenAddMisc.bind(this);
        this.onAddMisc = this.onAddMisc.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDeleteMiscItem = this.onDeleteMiscItem.bind(this);
        this.onOpenEdit = this.onOpenEdit.bind(this);
        this.updateTotal = this.updateTotal.bind(this);
        this.onMiscReasonChanged = this.onMiscReasonChanged.bind(this);
        this.onMiscDateChange = this.onMiscDateChange.bind(this);
        this.onSavePto = this.onSavePto.bind(this);
        this.openPto = this.openPto.bind(this);
        this.approvePto = this.approvePto.bind(this);
        this.hasUnapprovedPto = this.hasUnapprovedPto.bind(this);
        this.closePto = this.closePto.bind(this);
        this.deletePtoLine = this.deletePtoLine.bind(this);
    }
    onMiscDateChange(workDate) {
        const self = this;
        const clone = immutable.fromJS(this.state).toJS();
        if (workDate) {
            workDate = moment(workDate).format("MM-DD-YYYY");
           let schUrl =  `get-erp-aws-scheduleHours/${workDate}/`;
         if(self.props.role == "payroll-admin" || self.props.role == "supervisor") {
            schUrl =  `get-erp-aws-scheduleHours/${workDate}/${this.props.timecardId}`;
           }
            ajax.api()
                .get(schUrl)
                .then(function (res) {
                    const data = res.data;
                    console.log(data);
                    clone.showScheduleHoursDay = true;
                    clone.scheduleHoursDay = data;
                    self.setState(clone);
                })
                .catch(function (err) {
                    console.log(err);
                });
        }
        else {
            clone.showScheduleHoursDay = false;
            clone.scheduleHoursDay = "";
            self.setState(clone);
        }
    }

    updateTotal() {
        let vm = this.props.vm;
        let sum = vm.expenses.reduce((init, val) => init + val.unit, 0);
        this.state.totalExpense = sum;
    }

    validateMisc(misc) {
        let msg = [];
        if (!misc.date.trim()) {
            msg.push("Date is required");
        }

        if (isNaN(misc.time) || misc.time <= 0.0) {
            msg.push("Invalid Hours");
        }

        if (!misc.reasonCode.trim()) {
            msg.push("Reason is required");
        }

        if (!misc.reasonForChange &&
            (this.props.role == 'payroll-admin' || this.props.role == 'supervisor')) {
            msg.push("Reason for Change is required");
        }

        return msg;
    }

    onDeleteMiscItem(expenseId) {
        const self = this;
        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to delete this record?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is expenseId, expenseId is set as the 3rd parameter of context.message
            if (button === "yes") {
                context.message({
                    show: true,
                    type: "loading",
                    message: "Deleting Miscellaneous Item. Please wait..."
                });
                ajax.api()
                    .delete("delete-expense/" + s)
                    .then(function (res) {
                        if (self.props.onDeleteMiscItem) self.props.onDeleteMiscItem(s);
                        context.message({
                            show: false
                        });
                    })
                    .catch(function (err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"
                        });
                    });
            }
        }, expenseId);
    }

    onOpenAddMisc() {
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({
                showDialog: true,
                showDialogErrorMessage: false,
                dialogErrorMessage: [],
                dialogMode: "new",
                editedExpense: null,
                showMiscCodeDescription: false,
                miscCodeDescription: null

            }).toJS());
    }

    onUpdateMisc(expenseId, misc) {
        const self = this;
        const errors = this.validateMisc(misc);
        const clone = immutable.fromJS(this.state).toJS();
        clone.showDialogErrorMessage = errors.length > 0;
        clone.dialogErrorMessage = errors
        if (clone.showDialogErrorMessage) {
            this.setState(clone);
        } else {
            context.message({
                show: true,
                type: "loading",
                message: "Updating Miscellaneous Item. Please wait..."
            });

            const updateMiscFunc = function () {
                ajax.api()
                    .put(`update-expense/${expenseId}`, misc)
                    .then(function (res) {
                        context.message({
                            show: false
                        });
                        if (self.props.onUpdateMiscItem) self.props.onUpdateMiscItem(expenseId, res.data.expense);
                        clone.showDialog = false;
                        self.setState(clone);
                    })
                    .catch(function (err) {
                        context.message({
                            show: false
                        });
                        const data = err.response.data;
                        const msg = data.exceptionMessage || data.message;
                        clone.showDialogErrorMessage = true;
                        clone.dialogErrorMessage = [msg];
                        self.setState(clone);
                    });
            };

            if (self.props.role == "payroll-admin") {
                ajax.api()
                    .post(`validate-expense/${expenseId}`, misc)
                    .then(function (res) {
                        updateMiscFunc();
                    })
                    .catch(function (err) {
                        const msg = err.response.data.exceptionMessage || err.response.data.message;
                        if (err.response.data.code == 0x10001) {
                            context.message({
                                show: true,
                                type: "warning",
                                message: <div>
                                    <p>{msg}</p>
                                    <p>Are you sure to continue?</p>
                                </div>,
                                buttons: "yes,cancel"
                            }, function (button, state) {
                                if (button == "yes") {
                                    context.message({
                                        show: true,
                                        type: "loading",
                                        message: "Updating Miscellaneous Item. Please wait..."
                                    });
                                    updateMiscFunc();
                                } else {
                                    context.message({
                                        show: false
                                    })
                                }
                            });
                        } else {
                            context.message({
                                show: true,
                                type: "error",
                                message: msg,
                                buttons: "close"
                            });
                        }
                    });
            } else updateMiscFunc();
        }
    }

    onAddMisc(misc) {
        const self = this;
        const errors = this.validateMisc(misc);
        const clone = immutable.fromJS(this.state).toJS();
        clone.showDialogErrorMessage = errors.length > 0;
        clone.dialogErrorMessage = errors
        if (clone.showDialogErrorMessage) {
            this.setState(clone);
        } else {
            context.message({
                show: true,
                type: "loading",
                message: "Adding Miscellaneous Item. Please wait..."
            });
            const addMiscFunc = function () {
                ajax.api()
                    .post("add-expense", misc)
                    .then(function (res) {
                        context.message({
                            show: false
                        });

                        let data = res.data;
                        
                        if (data.isNewTimecardCreated) {
                            if (self.props.onNewTimecardAdded)
                                self.props.onNewTimecardAdded(data.newTimecardId);
                        }
                        else {
                            if (self.props.onAddMisc) 
                                self.props.onAddMisc(data.expense);
                        }
                        
                        clone.showDialog = false;
                        self.setState(clone);
                    })
                    .catch(function (err) {
                        context.message({
                            show: false
                        });
                        const data = err.response.data;
                        const msg = data.exceptionMessage || data.message;
                        clone.showDialogErrorMessage = true;
                        clone.dialogErrorMessage = [msg];
                        self.setState(clone);
                    });
            };

            if (self.props.role == "payroll-admin") {
                ajax.api()
                    .post("validate-expense", misc)
                    .then(function (res) {
                        addMiscFunc();
                    })
                    .catch(function (err) {

                        const msg = err.response.data.exceptionMessage || err.response.data.message;
                        if (err.response.data.code == 0x10001) {
                            context.message({
                                show: true,
                                type: "warning",
                                message: <div>
                                    <p>{msg}</p>
                                    <p>Are you sure to continue?</p>
                                </div>,
                                buttons: "yes,cancel"
                            }, function (button, state) {
                                if (button == "yes") {
                                    context.message({
                                        show: true,
                                        type: "loading",
                                        message: "Adding Miscellaneous Item. Please wait..."
                                    });
                                    addMiscFunc();
                                } else {
                                    context.message({
                                        show: false
                                    })
                                }
                            });
                        } else {
                            context.message({
                                show: true,
                                type: "error",
                                message: msg,
                                buttons: "close"
                            });
                        }
                    });
            } else addMiscFunc();
        }
    }
    onOpenEdit(expenseId) {
        let vm = this.props.vm;
        let selectedExpense = null;
        for (let i = 0; i <= vm.expenses.length; i++) {
            if (vm.expenses[i].expenseId === expenseId) {
                selectedExpense = vm.expenses[i];
                break;
            }
        }
        let description = "";
        for (let i = 0; i < vm.reasons.length; i++) {
            if (vm.reasons[i].code === selectedExpense.code) {
                description = vm.reasons[i].codeDescription;
                break;
            }
        }
        let daiyHoursText = util.getDailyHoursTextMiscAdd(selectedExpense.expenseDate, selectedExpense.AWSDailyWorkHours);
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({
                showDialog: true,
                showDialogErrorMessage: false,
                dialogErrorMessage: [],
                dialogMode: "edit",
                editedExpense: selectedExpense,
                showMiscCodeDescription: true,
                miscCodeDescription: description,
                scheduleHoursDay: daiyHoursText,
                showScheduleHoursDay: true,
            }).toJS());
    }
    onCancel() {
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({ showDialog: false }).toJS());
    }
    onMiscReasonChanged(expenseCode) {
        let vm = this.props.vm;
        let description = "";
        for (let i = 0; i < vm.reasons.length; i++) {
            if (vm.reasons[i].code === expenseCode) {
                description = vm.reasons[i].codeDescription;
                break;
            }
        }
        if (description) {
            this.setState(immutable.fromJS(this.state)
                .mergeDeep({
                    showMiscCodeDescription: true,
                    miscCodeDescription: description
                }).toJS());
        } else {
            this.setState(immutable.fromJS(this.state)
                .mergeDeep({
                    showMiscCodeDescription: false,
                    miscCodeDescription: ""
                }).toJS());
        }
    }

    onSavePto() {
        // reload Timecard screen
        if (this.props.onDeleteMiscItem)
            this.props.onDeleteMiscItem();

        this.setState({ showPtoDialog: false, showPtoListDialog: false });
    }

    openPto(action, ptoId) {
        ptoId = ptoId || 0;
        
        this.setState({
            ptoAction: action,
            showPtoDialog: (ptoId != 0),
            showPtoListDialog: (ptoId == 0),
            ptoDialogTitle: (ptoId == 0 ? "Unapproved Time-Off" : `${action} Time-Off Request`),
            selectedPtoId: ptoId
        });
    }

    approvePto(ptoId) {
        const self = this;
        context.message({
            show: true,
            type: "loading",
            message: "Approving. Please wait..."            
        });

        ajax.api()
            .post('update-pto', { ptoId: ptoId, action: 'approve' })
            .then(function(res){
                // reload Timecard screen
                if (self.props.onDeleteMiscItem) self.props.onDeleteMiscItem();

                context.message({
                    show: false
                });
            })
            .catch(function(err) {
                const message = err.response.data.exceptionMessage || err.response.data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: message,
                    buttons: "close"});
            });
    }

    hasUnapprovedPto() {
        const allowPtoAction = (this.props.vm.isPtoEnabled && this.props.role == "supervisor") || false;
        if (!allowPtoAction)
            return false;
            
        const expenses = this.props.vm.expenses;
        if (expenses.filter(e => e.ptoStatusCode == "Requested").length > 0) {
            this.setState({ showPtoListDialog: true, ptoDialogTitle: "Unapproved Time-Off" });
            return true;
        }
        
        return false;
    }

    closePto() {
        this.setState({
            showPtoDialog: false,
            showPtoListDialog: false,
            selectedPtoId: null
        });
    }

    deletePtoLine(ptoLineId) {
        const self = this;
        context.message({
            show: true,
            type: "info",
            message: "Are you sure you want to delete this time-off request?",
            buttons: "yes,no"
        }, function (button, s) {
            // s is ptoLineId, ptoLineId is set as the 3rd parameter of context.message
            if (button === "yes") {
                context.message({
                    show: true,
                    type: "loading",
                    message: "Deleting. Please wait..."
                });
                ajax.api()
                    .delete("delete-pto-line/" + s)
                    .then(function (res) {
                        // reload Timecard screen
                        if (self.props.onDeleteMiscItem) self.props.onDeleteMiscItem();
                        context.message({
                            show: false
                        });
                    })
                    .catch(function (err) {
                        const message = err.response.data.exceptionMessage || err.response.data.message;
                        context.message({
                            show: true,
                            type: "error",
                            message: message,
                            buttons: "close"
                        });
                    });
            }
        }, ptoLineId);
    }

    isAndroid() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf("android") > -1;
    }

    isIos() {
        var ua = navigator.userAgent.toLowerCase();
        return ua.indexOf('ipad') > - 1 || ua.indexOf('iphone') > -1;
    }

    render() {
        this.updateTotal();
        const self = this;
        const isMobile = this.isIos() || this.isAndroid();
        const clsRoot = isMobile? "ap-misc-mobile" : "ap-misc-container";
        let vm = this.props.vm;
        let dateList = util.dayListFromWeekEnding(this.props.weekEnding);
        let dateInput = null, hoursInput = null, reasonInput = null, noteInput = null, rfcInput = null;
        const allowEdit = `${this.props.allowEdit}` == "true";
        const showReasonForChange = (this.props.role == "supervisor" || this.props.role == "payroll-admin");

        const tcStatus = this.props.timecardStatus

        const action = { 
            addMisc: "addMisc", editMisc: "editMisc", deleteMisc: "deleteMisc", 
            addPto: "addPto", editPto: "editPto", deletePto: "deletePto", approvePto: "approvePto" };

        let allowActions = [];

        if (allowEdit) {
            allowActions.push(action.addMisc, action.deleteMisc, action.editMisc);

            if (vm.isPtoEnabled) {
                if (this.props.role == "supervisor" || this.props.role == "payroll-admin")
                    allowActions.push(action.addPto, action.editPto, action.deletePto, action.approvePto);
            }
        }
        console.log(allowActions);

        return (
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-12">
                        <div className={clsRoot}>
                            <div className="row">
                                <div className={allowActions.includes(action.addPto)? (isMobile? "col-xs-12 ap-mt-1" : "col-md-4") : "ap-hidden"}>
                                    <Button className="ap-fullsize btn-info" onClick={() => this.openPto("create", -1)}
                                        disabled={!allowActions.includes(action.addPto)}>Request Time-Off</Button>
                                </div>
                                <div className="col-md-4 hidden-sm hidden-xs">

                                </div>
                                <div className="col-xs-12 col-md-4 ap-float-right">
                                    <Button className={allowEdit ? "ap-fullsize btn-info" : "ap-hidden"} onClick={this.onOpenAddMisc}
                                        disabled={!allowActions.includes(action.addMisc)}>Add Miscellaneous Time</Button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xs-12 col-md-12">
                                    <div className="ap-misc-list">
                                        <div className="ap-section-header">
                                            <span className="ap-h3">Miscellaneous Time</span>
                                        </div>
                                        <div>
                                            {vm.expenses.map(e => <MiscListItem key={`${e.expenseId}_${this.props.allowEdit}`} 
                                                vm={e} timecardStatus={tcStatus} allowEdit={this.props.allowEdit}
                                                onEdit={allowActions.includes(action.editMisc)? self.onOpenEdit : null} 
                                                onDelete={allowActions.includes(action.deleteMisc)? self.onDeleteMiscItem : null}
                                                onOpenPto={allowActions.includes(action.editPto)? self.openPto : null}
                                                onApprovePto={allowActions.includes(action.approvePto)? self.approvePto : null}
                                                onDeletePtoLine={allowActions.includes(action.deletePto)? self.deletePtoLine : null} />)}
                                        </div>
                                        <div className="ap-bkg-color-gray ap-color-white ap-summary-container">
                                            <span className="ap-h4">Miscellaneous Total: </span><span>{util.toHrmString(this.state.totalExpense)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Modal show={this.state.showDialog} onHide={this.onCancel}>
                                <Modal.Header closeButton={true}>
                                    <Modal.Title>{this.state.mode === "update" ? "Edit" : "Add"} Miscellaneous Time</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <ControlLabel>Date <span className="ap-color-red">*</span></ControlLabel>
                                                <FormControl componentClass="select" inputRef={ref =>
                                                    dateInput = ref} onChange={(evt) => this.onMiscDateChange(evt.target.value)}
                                                    defaultValue={this.state.dialogMode === "edit" ? util.purifyTimepart(this.state.editedExpense.expenseDate) : ""}>
                                                    <option key="" value="">--Select a Date--</option>
                                                    {dateList.map(d => { return <option key={d} value={d}>{moment(d).format("ddd, MMM DD")}</option> })}
                                                </FormControl>
                                            </div>
                                            <div className="col-md-3">
                                                <ControlLabel>Hours <span className="ap-color-red">*</span></ControlLabel>
                                                <FormControl type="text" placeholder="0h 0m" inputRef={ref =>
                                                    hoursInput = ref}
                                                    defaultValue={this.state.dialogMode === "edit" ? util.toShortHmString(this.state.editedExpense.unit) : null} />
                                            </div>
                                            <div className="col-md-5">
                                                <ControlLabel>Reason <span className="ap-color-red">*</span></ControlLabel>
                                                <FormControl componentClass="select" inputRef={ref =>
                                                    reasonInput = ref}
                                                    defaultValue={this.state.dialogMode === "edit" ? this.state.editedExpense.code : null} onChange={(evt) => this.onMiscReasonChanged(evt.target.value)}>
                                                    <option key="" value="">--Select a Reason--</option>
                                                    {vm.reasons.map(r => <option key={r.code} value={r.code}>{r.codeName}</option>)}
                                                </FormControl>
                                            </div>
                                            {/* knguyen 7/25/2022: Hide this section and wait for decision on how to implement multi-descriptions support for same code*/}
                                            {/* knguyen 10/4/2023: Bring this back after implementation of PAP-961, Action Portal now has ability to override code's description */}
                                            <div className="col-md-12" dangerouslySetInnerHTML={{__html: this.state.miscCodeDescription}}>                                                
                                            </div>
                                            <div className={(this.state.showScheduleHoursDay && this.state.showMiscCodeDescription) ? "col-md-12" : "ap-hidden"}>
                                                <span className="ap-miscDesc-Text">
                                                    <br /><b><i>{this.state.scheduleHoursDay}</i></b>
                                                </span>
                                            </div>
                                            <div className="col-md-12">
                                                <ControlLabel>Note</ControlLabel>
                                                <FormControl componentClass="textarea" placeholder="Note" rows="4" inputRef={ref =>
                                                    noteInput = ref}
                                                    defaultValue={this.state.dialogMode === "edit" ? this.state.editedExpense.notes : null} />
                                            </div>
                                            <div className={`col-md-12 ${showReasonForChange ? "" : "ap-hidden"}`}>
                                                <ControlLabel>Reason for Change <span className="ap-color-red">*</span></ControlLabel>
                                                <FormControl componentClass="textarea" placeholder="Reason for Change" rows="2" inputRef={ref =>
                                                    rfcInput = ref} />
                                            </div>
                                            <div className="col-md-12">
                                                <Alert bsStyle="danger" className={this.state.showDialogErrorMessage ? "" : "ap-hidden"}>
                                                    <ul>
                                                        {this.state.dialogErrorMessage.map(m =>
                                                            <li key={m}>{m}</li>)}
                                                    </ul>
                                                </Alert>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Body>

                                <Modal.Footer>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <Button onClick={() =>
                                                    this.onAddMisc({
                                                        timecardId: this.props.timecardId,
                                                        date: dateInput.value,
                                                        time: util.hmStringToUnit(hoursInput.value),
                                                        reasonCode: reasonInput.value,
                                                        reasonDescription: reasonInput.options[reasonInput.selectedIndex].innerText,
                                                        note: noteInput.value,
                                                        reasonForChange: (rfcInput ? rfcInput.value : "")
                                                    })} className={this.state.dialogMode === "edit" ? "ap-hidden" : "btn-info ap-fullsize"}>Add
                                                </Button>
                                                <Button onClick={() =>
                                                    this.onUpdateMisc(this.state.editedExpense.expenseId, {
                                                        timecardId: this.props.timecardId,
                                                        date: dateInput.value,
                                                        time: util.hmStringToUnit(hoursInput.value),
                                                        reasonCode: reasonInput.value,
                                                        reasonDescription: reasonInput.options[reasonInput.selectedIndex].innerText,
                                                        note: noteInput.value,
                                                        reasonForChange: (rfcInput ? rfcInput.value : "")
                                                    })} className={this.state.dialogMode === "edit" ? "btn-info ap-fullsize" : "ap-hidden"}>Save
                                                </Button>
                                            </div>
                                            <div className="col-md-4">&nbsp;</div>
                                            <div className="col-md-4">
                                                <Button onClick={this.onCancel} className="ap-fullsize">Cancel</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Modal.Footer>
                            </Modal>

                            <Modal className="ap-pto-dialog" show={this.state.showPtoDialog} onHide={this.closePto} backdrop="static">
                                <Modal.Header closeButton={true}>
                                    <Modal.Title className="ap-pto-dialog-title">
                                        <i className="fa fa-calendar-o" /> {this.state.ptoDialogTitle}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <PtoDetail ptoId={this.state.selectedPtoId} onSaved={this.onSavePto} onClosed={this.closePto} userRole={this.props.role} action={this.state.ptoAction} timecardId={this.props.timecardId} />
                                </Modal.Body>
                            </Modal>

                            <Modal className="ap-pto-dialog" show={this.state.showPtoListDialog} onHide={this.closePto} backdrop="static">
                                <Modal.Header closeButton={true}>
                                    <Modal.Title className="ap-pto-dialog-title">
                                        <i className="fa fa-calendar-o" /> {this.state.ptoDialogTitle}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <PtoListByTimecard timecardId={this.props.timecardId} filterStatusCode="Requested" enableSelection={false} onSaved={this.onSavePto} onClosed={this.closePto} />
                                </Modal.Body>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}